module.exports = __webpack_public_path__ + "img/132.9.2f55f6a5.png";